import { createContext, useContext, useState } from "react";
import { fetchData } from "../../../lib/dashboard/data";
import useSWR from "swr";
import { sendData } from "../../../lib/dashboard/actions";
import { useDomesticMarketProductPriceChart } from "./DomesticMarketProductPriceChartContext";

const DomesticMarketProductPriceChartProducerContext = createContext();

const DomesticMarketProductPriceChartProducerProvider = ({ children }) => {
  const { setIsFavoritesModal } = useDomesticMarketProductPriceChart();

  const [producerInputValue, setProducerInputValue] = useState({
    company: null,
    group: null,
    commodity: null,
  });

  const [producerChartData, setProducerChartData] = useState({
    data: [],
    isLoading: false,
  });

  const companies = useSWR("/domestic/producer/company", fetchData, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const groups = useSWR(
    producerInputValue.company
      ? `/domestic/producer/group/${producerInputValue.company.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const commodities = useSWR(
    producerInputValue.group
      ? `/domestic/producer/commodity/${producerInputValue.company.id}/${producerInputValue.group.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const handleShowChart = async (body) => {
    setProducerChartData((prev) => ({ ...prev, isLoading: true }));
    const res = await sendData(body, "/domestic/producer/price-chart");
    if (res?.status === 200)
      setProducerChartData({ data: res.data, isLoading: false });
    setProducerChartData((prev) => ({ ...prev, isLoading: false }));
  };

  const handleSelectedProducerFavorite = async (favorite) => {
    const { commodity, commodity_id, company, company_id, group, group_id } =
      favorite;

    setProducerInputValue((prev) => ({
      ...prev,
      company: { id: company_id, name: company },
      group: { id: group_id, name: group },
      commodity: commodity && { id: commodity_id, name: commodity },
    }));

    await handleShowChart({
      company_id,
      group_id,
      commodity_id,
    });

    setIsFavoritesModal(false);
  };

  return (
    <DomesticMarketProductPriceChartProducerContext.Provider
      value={{
        producerInputValue,
        setProducerInputValue,
        companies,
        groups,
        commodities,
        producerChartData: producerChartData.data,
        isProducerChartLoading: producerChartData.isLoading,
        setProducerChartData,
        handleShowChart,
        handleSelectedProducerFavorite,
      }}
    >
      {children}
    </DomesticMarketProductPriceChartProducerContext.Provider>
  );
};

export default DomesticMarketProductPriceChartProducerProvider;

export const useDomesticMarketProductPriceChartProducer = () => {
  return useContext(DomesticMarketProductPriceChartProducerContext);
};
